import { Outlet } from "react-router-dom";
import { Oval } from "react-loader-spinner";
import React, { useEffect, useState } from "react";
import useFetch from "./useFetch";
import Navbar from "./NavBar";
import { buildApiUrl } from "./api";
import { AuthTokenRetrieve } from "./AuthTokenRetrieve";
const ContextManager = (props) =>{
    const { type} = props;
    const { data: foodData, isPending } = useFetch({ url: buildApiUrl("/food/server"), skip: type !== 'Food' && type !== 'FoodDiary' });
    const { shouldShow: hasPrivateAccess } = AuthTokenRetrieve();
    const { data: tabData, isPending: tabsPending, error: tabsError, setData: setTabData } = useFetch({ url: buildApiUrl("/tabs/server/"), skip: type !== 'GuitarTabs' || !hasPrivateAccess });
    const data = type === 'Food' || type === 'FoodDiary' ? (foodData ? foodData : '') : type === 'GuitarTabs' ? (tabData ? tabData : []) : '';
    const contextIsPending = type === 'Food' || type === 'FoodDiary' ? isPending : type === 'GuitarTabs' ? tabsPending : false;
    const [linksForNav, setLinksForNav] = useState([]);
    useEffect(()=>{
        
        if(type ==='Food'){
            document.title = 'Lester Food';
            const foodLinks = [
                {to:"/food", value:"Food Home"},
                {to:"/food/ShoppingList", value:"Shopping Lists"},
                {to:"/food/RandomFood", value:"Random Food"},
            ];
            if (hasPrivateAccess) {
                foodLinks.splice(1, 0, {to:"/food/add", value:"Add Recipe"});
                foodLinks.splice(2, 0, {to:"/food/edit", value:"Edit Recipe"});
                foodLinks.push({to:"/food/ingredient-review", value:"Ingredient Review"});
            }
            setLinksForNav(foodLinks)
        }else if(type ==='FoodDiary'){
            document.title = 'Lester Food Diary';
            const diaryLinks = [
                {to:"/food-diary", value:"Diary Home"},
                {to:"/food", value:"Recipe Hub"}
            ];
            if (hasPrivateAccess) {
                diaryLinks.splice(1, 0,
                    {to:"/food-diary/add-meal", value:"Add Meal"},
                    {to:"/food-diary/add-symptom", value:"Add Symptom"},
                    {to:"/food-diary/meals", value:"Meal History"},
                    {to:"/food-diary/symptoms", value:"Symptom History"},
                    {to:"/food-diary/bowel-events", value:"Bowel Events"},
                    {to:"/food-diary/daily-context", value:"Daily Context"},
                    {to:"/food-diary/summary", value:"Summary"}
                );
            }
            setLinksForNav(diaryLinks)
        }else if(type == 'Workout'){
            document.title = 'Lester';
            setLinksForNav([
                {to:"/workout", value:"Workouts Home"},
                {to:"/workout/AddLift", value:"Add Lift"}

                
            ])
        }else if(type == 'Sports'){
            document.title = 'Lester Sports';
            setLinksForNav([
                {to:"/sports", value:"Home"},
                {to:"/sports/formula1", value:"F1"},
                {to:"/sports/fantasyfootball", value:"FF"}
                
            ])
        }else if(type === 'GuitarTabs'){
            document.title = 'Lester Guitar Tabs';
            setLinksForNav(hasPrivateAccess ? [
                {to:"/guitar-tabs", value:"Tabs Home"},
                {to:"/guitar-tabs/add", value:"Add Tab"},
                {to:"/guitar-tabs/view", value:"View Tab"}
            ] : [])
        }else if(type === 'BabyTracker'){
            document.title = 'Lester Baby Tracker';
            setLinksForNav(hasPrivateAccess ? [
                {to:"/baby-tracker", value:"Baby Home"},
                {to:"/baby-tracker/diapers", value:"Diapers"},
                {to:"/baby-tracker/feeding", value:"Feeding"},
                {to:"/baby-tracker/feeding-chart", value:"Feeding Chart"},
                {to:"/baby-tracker/daily-history", value:"Daily History"},
                {to:"/baby-tracker/frozen-milk", value:"Frozen Milk"},
                {to:"/baby-tracker/pumping", value:"Pumping"},
                {to:"/baby-tracker/medicine", value:"Medicine"},
                {to:"/baby-tracker/medicine-reminders", value:"Med Reminders"},
                {to:"/baby-tracker/sleep", value:"Sleep"},
                {to:"/baby-tracker/event-log", value:"Event Log"}
            ] : [])
        }else if(type === 'Scrapbook'){
            document.title = 'Jon Scrapbook';
            setLinksForNav(hasPrivateAccess ? [
                {to:"/scrapbook", value:"Jon Scrapbook"},
                {to:"/scrapbook/admin", value:"Scrapbook Admin"},
                {to:"/baby-tracker", value:"Baby Tracker"}
            ] : [])
        }else{
            document.title = 'Lester';
            setLinksForNav([
                {to:"/food", value:"Food"},
                {to:"/workout", value:"Workouts"},
                {to:"/sports", value:"Sports"},
                ...(hasPrivateAccess ? [
                    {to:"/guitar-tabs", value:"Guitar Tabs"},
                    {to:"/food-diary", value:"Food Diary"},
                    {to:"/baby-tracker", value:"Baby Tracker"},
                    {to:"/scrapbook", value:"Jon Scrapbook"}
                ] : [])
            ])
        }
    }, [type, hasPrivateAccess]);
    return (
        <div>
            <Navbar linksForNav={linksForNav}></Navbar>
            <div className="Body">
            {contextIsPending && (
                    <Oval
                    height="80"
                    width="80"
                    ariaLabel="loading"
                    color="red"
                    visible={true}
                    secondaryColor="gray"
                    strokeWidth={2}
                    strokeWidthSecondary={2}
                    />
                )}
                <Outlet context={{data, setData: setTabData, error: tabsError}}></Outlet>
                </div>
        </div>
    )
}
export default ContextManager;
